import { render } from "./expertreportdetailsview.vue?vue&type=template&id=101d5f15"
import script from "./expertreportdetailsview.vue?vue&type=script&lang=js"
export * from "./expertreportdetailsview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__